import Icon from 'Common/components/icons/Icon';
import colors from 'Application/theme/colors';

const OnHoldIcon = () => <Icon icon="pauseCircleFilledRounded" color={colors.error.main} />;

export default OnHoldIcon;
